/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/25/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {CURRENT_FAULT_STATES, FAULT_COLORS} from '../faults/common/FaultsConst'
import { PieChart, Pie, Cell, Tooltip, Sector } from 'recharts';

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) {
        return null;
    }

    const item = payload[0];

    const dotColor = item.fill || item.color || (item.payload && item.payload.fill) || '#ff2d4d';

    return (
        <div className="chart-tooltip-box">
            <span className="chart-tooltip-dot" style={{ backgroundColor: dotColor }} />
            <span className="chart-tooltip-text">
                {item.name}: {Number(item.value).toFixed(2)}
            </span>
        </div>
    );
};

const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={outerRadius - 1}
                outerRadius={outerRadius + 10}
                startAngle={0}
                endAngle={360}
                fill={fill}
                fillOpacity={0.25}
            />
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
                stroke="#ffffff"
                strokeWidth={1}
            />
        </g>
    );
};

class AssetChart extends React.Component {

    constructor(props) {
        super(props)
        this.state = { activeIndex: null, animKey: 0 }
    }

    componentDidMount() {
        this.setState({ animKey: Date.now() })
    }

    onPieEnter = (_, index) => {
        this.setState({ activeIndex: index })
    }

    onPieLeave = () => {
        this.setState({ activeIndex: null })
    }

    render() {
        const {intl, asset} = this.props

        const colors = []
        const data = []
        let hasTooltip = true

        if (asset.faultsCount > 0) {
            CURRENT_FAULT_STATES.forEach(s => {
                const value = asset.faultStatesCount[s] || 0
                if (value > 0) {
                    if (value === 1) {
                        data.push({
                            name: intl.formatMessage({id: 'asset.attr.faults-' + s + '.one'}),
                            value,
                        })
                        }
                        else {
                            data.push({
                                name: intl.formatMessage({id: 'asset.attr.faults-' + s}),
                                value,
                            })
                        }
                        colors.push(FAULT_COLORS[s])
                    }
                }
            )
        } else {
            data.push({
                name: intl.formatMessage({id: 'asset.attr.noFaults'}),
                value: 1,
            })
            colors.push(FAULT_COLORS.CLOSED_RESOLVED)
            hasTooltip = false
        }

        const size = this.props.height || 200

        const centerBlock = (
            <div className="center-block">
                <div className="title">{asset.faultsCount+''}</div>
                <div className="subtitle">{intl.formatMessage({id: (asset.faultsCount === 1 ? 'fleet.attr.faultsCountOne' : 'fleet.attr.faultsCount')}).toUpperCase()}</div>
            </div>
        )

        const chart = (
            <div className="chart-pie-container" style={{ width: size, height: size }}>
                <PieChart width={size} height={size}>
                    <Pie key={this.state.animKey} data={data} dataKey="value" innerRadius="62.475%" outerRadius="73.5%" startAngle={90} endAngle={-270}
                        animationBegin={0}
                        animationDuration={900}
                        activeIndex={this.state.activeIndex}
                        activeShape={renderActiveShape}
                        onMouseEnter={this.onPieEnter}
                        onMouseLeave={this.onPieLeave}
                    >
                        {data.map((entry, index) => (
                            <Cell key={index} fill={colors[index]} />
                        ))}
                    </Pie>
                    {hasTooltip && <Tooltip
                        content={<CustomTooltip />}
                        wrapperClassName="chart-tooltip"
                        cursor={false}
                    />}
                </PieChart>
                {centerBlock}
            </div>
        )

        if (this.props.onClick == null) {
            return (
                <div className="scuf-chart">
                    {chart}
                </div>
            )
        }
        return (
            <div className="scuf-chart" onClick={() => this.props.onClick()}>
                {chart}
            </div>
        )
    }
}

export default injectIntl(AssetChart)